import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const InformeListaSerieService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Informe/InformeListaSerie",
            values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { InformeListaSerieService };